import React from 'react';
import { LabelContainer } from './Label.styled';

export const Label = ({ children, ...otherProps }) =>
    <LabelContainer { ...otherProps }>
        <div>{children}</div>
    </LabelContainer>;